import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import deepClone from '../../foundation/js/deepClone'
import getLabelFromStore from '../../foundation/js/getLabel'
import GroupPost from '../GroupPost/GroupPost'

export default {
    name: "PostsList",    
    components: {   
        GroupPost
    },
    props: {
        guid: {
            type: String,
            required: true
        },
        groupId: {
            type: String,
            required: true
        },
        isClosedGroup: {
            type: Boolean,
            required: true
        },
        isLoggedIn: {
            type: Boolean,
            required: true,
            default: false
        },
        loginUrl: {
            type: String,
            required: true
        },
        hasMemberAccess: {
            type: Boolean,
            required: true,
            default: false
        },
        skip: {
            type: Number,
            required: true,
            default: 0
        },
        take: {
            type: Number,
            required: false,
            default: 10
        },
        universId: {
            type: String,
            required: true
        },
        numberOfMembers: {
            type: Number,
            required: true,
            default: 0
        }
    },
    setup(props) {
        const store = useStore()
        const numberOfItems = ref(0)

        const posts = computed(() => store.state.search.results[props.guid] ?? [])

        const totalAmount = computed(() => {
            return store.state.search.scoped_total[props.guid] ?? 0
        })
            
        const showSpinner = computed(()=> store.state.search.search_inprogress[props.guid] )

        onMounted(() => {
            initFetchPosts()
        })

        const getLabel = (key, strings) => {
            let label = getLabelFromStore({
                labelKey: key,
                labelCollection: 'PostsList'
            })

            if (strings) {
                strings.forEach((str, index) => {
                    label = label.replace(`{${index}}`, str)
                })
            }

            return label
        }

        const initFetchPosts = function() {
            store.commit('search/set_replaceQueryInUrl', false)

            store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: props.take,
                showMorePageSize: props.take,
                url: process.env.GET_POSTS_LIST + "?id=" + props.groupId + '&universId=' + props.universId
            })

            store.dispatch('search/performSearch', {
                guid: props.guid,
                query: '',
                skip: props.skip,
                take: props.take
            })
        }

        const handlePostClick = (e, post) => {
            if (!props.isLoggedIn) {
                store.dispatch('main/openPageOverlay', {
                    overlayContent: "LoginOverlay",
                    returnTarget: e.currentTarget
                })
                return
            }

            if (!props.isClosedGroup) {
                window.location.href = post.url
                return
            }

            if (!props.hasMemberAccess) {
                store.dispatch('main/openPageOverlay', {
                    overlayContent: "ClosedGroupOverlay",
                    returnTarget: e.currentTarget
                })

                return
            }

            window.location.href = post.url
        }
        

        const getMorePosts = () => {
            store.dispatch('search/performMoreSearch', { guid: props.guid })
        }

        const openMemberOverlay = (e) => {
            store.dispatch("main/openPageOverlay", {
                overlayContent: "MemberListOverlayCancerforum",
                returnTarget: e.currentTarget,
            })
        }

        return {
            openMemberOverlay,
            showSpinner,
            getLabel,
            numberOfItems,
            posts,
            totalAmount,
            getMorePosts,
            handlePostClick,
        }
    }
}